/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelMealReasonAdminDto } from '../models/CancelMealReasonAdminDto';
import type { CancelMealReasonAdminListedDtoAdmin } from '../models/CancelMealReasonAdminListedDtoAdmin';
import type { GetCancelMealReasonsAdminOptions } from '../models/GetCancelMealReasonsAdminOptions';
import type { PostPutCancelMealReasonRequestAdmin } from '../models/PostPutCancelMealReasonRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CancelMealReasonsService {
    /**
     * **Required Policy:** `ViewCancelMealReasons`
     * @returns CancelMealReasonAdminDto OK
     * @throws ApiError
     */
    public static getCancelMealReasonByIdAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CancelMealReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cancelmealreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCancelMealReasons`
     * @returns CancelMealReasonAdminDto OK
     * @throws ApiError
     */
    public static putCancelMealReasonAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutCancelMealReasonRequestAdmin,
    }): CancelablePromise<CancelMealReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cancelmealreasons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCancelMealReasons`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCancelMealReasonAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/cancelmealreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCancelMealReasons`
     * @returns CancelMealReasonAdminListedDtoAdmin OK
     * @throws ApiError
     */
    public static getCancelMealReasonsAdmin({
        options,
    }: {
        options?: GetCancelMealReasonsAdminOptions,
    }): CancelablePromise<Array<CancelMealReasonAdminListedDtoAdmin>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cancelmealreasons',
            query: {
                'options': options,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCancelMealReasons`
     * @returns CancelMealReasonAdminDto Created
     * @throws ApiError
     */
    public static postCancelMealReasonAdmin({
        requestBody,
    }: {
        requestBody?: PostPutCancelMealReasonRequestAdmin,
    }): CancelablePromise<CancelMealReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/cancelmealreasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
